import router from '@router/index';

export function toLogin() {
    localStorage.clear();
    let currentPath = location.href.replace(location.origin, '');
    if (/^\/#/.test(currentPath)) {
        currentPath = currentPath.substring(2, currentPath.length);
    }
    const { href } = router.resolve({
        name: 'Login',
        query: {
            redirectUrl: currentPath
        }
    });
    location.replace(href);
}
